import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/saq-route-producteurs.module.css';

interface SaqRouteProducteursThemeProps extends HTMLAttributes<HTMLDivElement> {
    className?: string | null;
    children: ReactNode;
}

function SaqRouteProducteursTheme({
    children,
    className = null,
    ref = null,
    ...props
}: SaqRouteProducteursThemeProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={ref} {...props}>
            {children}
        </div>
    );
}

export default SaqRouteProducteursTheme;
